import * as React from 'react';
import { Styled } from './dot-loading-indicator.styles';
export const DotLoadingIndicator = ({ className, ...props }) => (React.createElement(Styled.DotLoadingIndicator, { className: className, ...props },
    React.createElement(Styled.Dot1, null),
    React.createElement(Styled.Dot2, null),
    React.createElement(Styled.Dot3, null)));
DotLoadingIndicator.displayName = 'DotLoadingIndicator';
//# sourceMappingURL=dot-loading-indicator.js.map